import { render, staticRenderFns } from "./BaseListGroup.vue?vue&type=template&id=a3838182"
import script from "./BaseListGroup.vue?vue&type=script&lang=js"
export * from "./BaseListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports